import React, { Component } from 'react';
import Header from './../components/Header';
import Partners from '../components/Partners';

class ContestPage extends Component {
  render() {
    return (
      <div className="contest-page bg-gray-50 text-gray-800">
        <Header />

        <div className="main-content lg:mt-[100px] mt-[80px]">
          <div className="container mx-auto px-4 max-w-4xl">
            <h1 className="font-bold mb-4 text-center text-[#1b75bb]">
              Veletržní soutěž
            </h1>



            <p className="text-lg text-center mb-4">
              Zapoj se do veletržní soutěže a vyhraj jednu z mnoha hodnotných cen!
            </p>

            <h2 className="text-2xl font-semibold mb-4">Jak se zapojit?</h2>
            <div className="flex justify-center">
              <ul className="space-y-2 mb-4 text-left">
                <li className="pl-6 relative before:content-['→'] before:absolute before:left-0 before:text-black before:font-bold">
                  navštiv tři stánky vystavujících firem
                </li>
                <li className="pl-6 relative before:content-['→'] before:absolute before:left-0 before:text-black before:font-bold">
                  získej od nich klíčová slova a zaregistruj je na <a href="https://www.stud.fit.vutbr.cz/~xvasil10/fair/public/login">webové stránce soutěže</a>
                </li>
                <li className="pl-6 relative before:content-['→'] before:absolute before:left-0 before:text-black before:font-bold">
                  získej heslo, zapiš ho na soutěžní stránku v průvodci, stránku vytrhni a vhoď ji do urny u vchodu
                </li>
                <li className="pl-6 relative before:content-['→'] before:absolute before:left-0 before:text-black before:font-bold">
                  dej si kafíčko a počkej do <strong>14:00</strong>, kdy proběhne vyhlášení vítězů!
                </li>
              </ul>
            </div>

            <h2 className="text-2xl font-semibold mb-4">Hlavní ceny</h2>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
              <div className="bg-white rounded-2xl shadow-lg p-4 text-center">
                <img
                  src="/data/images/monitor.jpg"
                  alt="Monitor Lenovo"
                  className="mx-auto mb-4 rounded h-32 object-cover"
                />
                <h3 className="font-bold">1. místo</h3>
                <p>Monitor Lenovo ThinkVision T24d</p>
              </div>
              <div className="bg-white rounded-2xl shadow-lg p-4 text-center">
                <img
                  src="/data/images/poukaz.png"
                  alt="Dárkový poukaz"
                  className="mx-auto mb-4 rounded h-32 object-cover"
                />
                <h3 className="font-bold">2. místo</h3>
                <p>Dárkový poukaz do e-shopu Alza.cz v hodnote 3000Kč</p>
              </div>
              <div className="bg-white rounded-2xl shadow-lg p-4 text-center">
                <img
                  src="/data/images/sluchadla.webp"
                  alt="Sluchátka Marshall IV"
                  className="mx-auto mb-4 rounded h-32 object-cover"
                />
                <h3 className="font-bold">3. místo</h3>
                <p>Sluchátka Marshall IV</p>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
                <div className="bg-white rounded-2xl shadow-lg p-2 text-center col-span-1 md:col-span-2 md:col-start-2">
                <img
                  src="/data/images/other.png"
                  alt="Další ceny"
                  className="mx-auto rounded h-44 object-cover mb-3 mt-3"
                />
                <h3 className="font-bold">a mnoho dalších!</h3>
                <p>Fotoaparát Instax Mini, batohy, powerbanky,...</p>
                </div>
            </div>
          </div>
        </div>



        <div className="bottom-0 w-full mt-4">
          <Partners />
        </div>
      </div>
    );
  }
}

export default ContestPage;
